import {Typography} from '@mui/material';
import {formatSecondsToTime} from 'models';
import {useMemo} from 'react';
import {useSelector} from 'react-redux';
import {timeTrackerSelector} from 'store/timeTracker';
interface TimeTrackerPopoverCounterProps {
    itemDataId?: string;
    withoutTypography?: boolean;
    trackerValue?: number;
}
export const TimeTrackerCounter = ({
    itemDataId,
    withoutTypography = false,
    trackerValue = 0,
}: TimeTrackerPopoverCounterProps) => {
    const {counterValueInRedux} = useSelector(timeTrackerSelector);
    const {selectedTimeTrackInRedux} = useSelector(timeTrackerSelector);

    const isSelectITemData = useMemo((): boolean => {
        if (!itemDataId) {
            return true;
        }
        if (selectedTimeTrackInRedux) {
            return selectedTimeTrackInRedux.itemDataId === itemDataId;
        }
        return false;
    }, [itemDataId, selectedTimeTrackInRedux]);
    return (
        <>
            {withoutTypography ? (
                counterValueInRedux && isSelectITemData ? (
                    formatSecondsToTime(counterValueInRedux)
                ) : (
                    '00:00:00'
                )
            ) : (
                <Typography variant="h3" color={'primary.main'}>
                    {counterValueInRedux && isSelectITemData
                        ? formatSecondsToTime(counterValueInRedux + trackerValue)
                        : '00:00:00'}
                </Typography>
            )}
        </>
    );
};
export default TimeTrackerCounter;
